import { useEffect, useState } from "react"
import { DateAPI, GetPatientsOfProfessionalResponsePayload } from "pokal_api"
import { useNavigate } from "react-router-dom"
import { useAppSelector } from "../redux/store/hooks"
import { selectDashboardSelectedPatient } from "../redux/ProfessionalDashboard"
import DashboardWrapper from "../component/DashboardWrapper"
import ReportList from "../component/dashboard_report/ReportList"
import NoteList from "../component/NoteList"
import RequirePatientSelection from "../component/require/RequirePatientSelection"
import MonitoringAnalysisPanel from "../component/analysis/monitoring/MonitoringAnalysisPanel"
import { NAVIGATION_VIEW, NavigationPaths } from "../navigation/NavigationController"
import { ArrayElement } from "../types/ArrayElement"
import mockPatient from "../onboarding/mock/mockPatient"
import {
    mockPatientUsed,
    selectOnboardingIsRunningState,
    selectOnboardingStep
} from "../redux/Onboarding"

export default function PatientAnalyseView() {
    const [patient, setPatient] =
        useState<ArrayElement<GetPatientsOfProfessionalResponsePayload> | null>(null)
    const [isExpanded, setIsExpanded] = useState(false)

    const fetchedPatient = useAppSelector(selectDashboardSelectedPatient)
    const mockedPatient = mockPatient()
    const running = useAppSelector(selectOnboardingIsRunningState)
    const step = useAppSelector(selectOnboardingStep)
    const navigate = useNavigate()

    useEffect(() => {
        if (mockPatientUsed(running, step)) {
            setPatient(mockedPatient[0])
        } else {
            setPatient(fetchedPatient)
        }
    }, [running, step, fetchedPatient])

    function genderLabel(gender: string | null | undefined): string {
        if (gender === "male") return "Männlich"
        if (gender === "female") return "Weiblich"
        return "Sonstiges"
    }

    return (
        <RequirePatientSelection>
            {patient !== null && (
                <DashboardWrapper
                    onClick={() => navigate(NavigationPaths[NAVIGATION_VIEW.PATIENT_OVERVIEW].path)}
                    title={`${patient.firstName} ${patient.lastName}`}
                >
                    <div className="flex flex-col space-y-4">
                        <div className="bg-gray-50 border border-gray-200 rounded-lg px-4 py-2 flex items-center gap-6">
                            <span className="text-sm font-semibold text-gray-800">
                                {patient.firstName} {patient.lastName}
                            </span>
                            <span className="text-xs text-gray-500">
                                Geb.: {DateAPI.timestampToString(new Date(patient.birthdate).getTime(), false)}
                            </span>
                            <span className="text-xs text-gray-500">BMI: {patient.bmi ?? "—"}</span>
                            <span className="text-xs text-gray-500">{genderLabel(patient.gender)}</span>
                            <button
                                onClick={() => setIsExpanded(prev => !prev)}
                                className="ml-auto text-xs text-gray-500 hover:text-gray-700 flex items-center gap-1"
                            >
                                {isExpanded ? "▲ Ausblenden" : "▼ Berichte & Notizen"}
                            </button>
                        </div>
                        {isExpanded && (
                            <>
                                <ReportList />
                                <NoteList />
                            </>
                        )}
                        <MonitoringAnalysisPanel
                            patientId={patient.id}
                            onClose={() => navigate(NavigationPaths[NAVIGATION_VIEW.PATIENT_OVERVIEW].path)}
                        />
                    </div>
                </DashboardWrapper>
            )}
        </RequirePatientSelection>
    )
}
